import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Une classes condicionais (clsx) resolvendo conflitos do Tailwind (twMerge).
 *  Padrão herdado do aura-tech-website (consistência cross-repo). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
